import { render, staticRenderFns } from "./MinimalHeader.vue?vue&type=template&id=8cb5b9e6&lang=pug&"
import script from "./MinimalHeader.vue?vue&type=script&lang=js&"
export * from "./MinimalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports